import React, {Component} from 'react';
import {Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import axios from 'axios';
import {serverPath} from "../common";
import {renderReports} from "../ViewReportsModal";

class ReportModal extends (Component){
    constructor(props){
        super(props);
        this.state={
            isOpen: false,
            existingReports: props.existingReports,
			user: props.user,
			canSubmitReport: props.canSubmitReport,
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.sendReport = this.sendReport.bind(this);
    }
    toggleModal() {
        let self = this;
        this.setState({isOpen: !self.state.isOpen});
	}
    componentWillReceiveProps(nextProps) {
        this.setState({
            existingReports: nextProps.existingReports,
			user: nextProps.user,
			canSubmitReport: nextProps.canSubmitReport,
        })
    }

    sendReport(){
        const reportText = this.reportText.value;
        if(reportText.trim().length === 0){
            alert("Polje za opis greške ne sme biti prazno");
            return;
        }
        const params = new FormData();
        params.append('action', 'createReport');
        params.append('problemId', this.props.problemId);
        params.append('reportText', reportText.trim());
        axios.post(serverPath + "reportService.php", params).then((resp)=>{
            if(resp.data === null || resp.data === false){
                alert("Nije uspelo prijavljivanje greške!" +
                    "Pokušajte ponovo, ukoliko se problem ponovi kontaktirajete administratora");
            }
            else{
				let newReport = {
					reporter: this.state.user.userId,
					description: reportText.trim(),
					idReport: resp.data.lastInsertId,
				}
				if(this.state.existingReports !== null){
					this.state.existingReports.push(newReport);
					this.setState({
						existingReports: this.state.existingReports,
					})
				}
				else{
					this.setState({
						existingReports: [newReport]
					})
				}
				this.setState({
					canSubmitReport: resp.data.canSubmitNextReport
				})
                this.toggleModal();
                alert("Uspešno prijavljena greška.");
            }
        });
    }

    render(){
        return(
            <React.Fragment>
				{
					this.state.canSubmitReport ?
					<Button color={'danger'}
                        onClick={this.toggleModal}>Prijavi grešku</Button>
						:
						<span/>
				}
                <Modal isOpen={this.state.isOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        Prijavite grešku na zadatku
                    </ModalHeader>
                    <ModalBody>

                        {
                            this.state.existingReports.length > 0 ?
                                <p>Već prijavljene greške na ovom zadatku</p>
                                :
                                <p>Nema do sada prijavljenih grešaka</p>
                        }
                        { renderReports(this.state.existingReports, this.state.user)}
                        <Form>
                            <FormGroup>
                                <Label htmlFor={'reportText'}>Opis greške</Label>
                                <Input name={'reportText'}
                                       type={'textarea'}
                                       innerRef={input=>this.reportText = input}/>
                            </FormGroup>
                            <Button color={'primary'}
                                    type={'submit'}
                                    onClick={(e)=>{
                                        this.sendReport();
                                        e.preventDefault();
                                    }}>Prijavi</Button>
                        </Form>
                    </ModalBody>
                </Modal>

            </React.Fragment>
        )
    }


}
export {ReportModal}
